import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type TNotificationVariant = 'informative' | 'warning';

export enum TNotificationActionType {
  CALLBACK = 'callback',
  ROUTER = 'router',
}
interface INotificationActionBase {
  label: string;
}

interface INotificationCallbackAction extends INotificationActionBase {
  type: TNotificationActionType.CALLBACK;
  callback: () => void;
}

interface INotificationRouterAction extends INotificationActionBase {
  type: TNotificationActionType.ROUTER;
  routerLink: string | string[];
}

export type INotificationAction =
  | INotificationCallbackAction
  | INotificationRouterAction;

export interface INotification {
  variant: TNotificationVariant;
  title: string;
  message: string;
  life?: number;
  action?: INotificationAction;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private _notificationSubject = new Subject<INotification[]>();

  notifications$ = this._notificationSubject.asObservable();

  /**
   * The default duration of a notification in milliseconds
   */
  readonly DEFAULT_DURATION: number = 3000;

  showNotifications(notifications: INotification[]): void {
    if (!notifications?.length) {
      return;
    }

    const normalizedNotifications: INotification[] = notifications.map(
      (notification: INotification) => ({
        ...notification,
        life: notification?.life ?? this.DEFAULT_DURATION,
      }),
    );

    this._notificationSubject.next(normalizedNotifications);
  }
}
